import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_site_footer = _resolveComponent("site-footer")!
  const _component_modal = _resolveComponent("modal")!
  const _component_loading_screen = _resolveComponent("loading-screen")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view, null, {
      default: _withCtx(({ Component }) => [
        _createVNode(_Transition, {
          name: "fade",
          mode: "out-in",
          duration: 500
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }),
    (_ctx.$route.name)
      ? (_openBlock(), _createBlock(_component_site_footer, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_modal),
    _createVNode(_component_loading_screen, {
      "data-cy": "routeLoaded",
      display: !_ctx.$route.name
    }, null, 8, ["display"])
  ], 64))
}